import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function TotalTable() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedDisplayColumn } = planningBottomup;

  const totalField = [
    {
      keyName: 'totalUKBuyUnits',
      name: 'Total UK Buy Units',
    },
    // {
    //   keyName: "totalSalesValue",
    //   name: "Total Sales Value",
    // },
  ];

  const isTableVisible = totalField.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));

  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {totalField.map((totalFielsItem, i) => {
              const isVisible = checkVisibleBottomUp(totalFielsItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{totalFielsItem.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {totalField?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {trItem[tdItem.keyName] || 0}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default TotalTable;
